import { RouteGeometry, VoyageRouteLineFeature } from "../models/voyage-routing-model";

export const legForEndPoint = (legs: VoyageRouteLineFeature[], coord: [number, number], idx: number): VoyageRouteLineFeature|undefined => {
    const res = legs.filter(leg => {
        const coords = leg.geometry.coordinates;
        return coords && coords.length === 2 &&
            coords[idx].length === 2 &&
            coords[idx][0] === coord[0] &&
            coords[idx][1] === coord[1];
    })

    if (res.length === 1) return res[0];
}

export const toDegrees = (rad: number): number => rad * 180 / Math.PI;
export const toRadians = (deg: number): number => Math.PI * deg / 180;

export function isPilotPointName(name?: string|null): boolean
{
    if (!name) return false;
    const normalized = name.trim().toUpperCase();
    return normalized.includes("PILOT") ||
        normalized.includes("PLT") ||
        normalized.includes("P/");
}

// A route may only carry the two outermost pilot points (departure + arrival). Name-based
// detection also flags interior points such as "20NM to Pilot", so once all candidates are
// found we keep only the first and the last (the outermost) and un-flag everything in
// between. Mutates the passed geometry.
export function keepOutermostPilotPoints(geometry: RouteGeometry): void
{
    if (!geometry) return;

    const pilotIndices: number[] = [];
    for (let i = 0; i < geometry.length; i++)
    {
        const feature = geometry[i];
        if (feature.geometry.type === "Point" && feature.properties.pilotPoint)
        {
            pilotIndices.push(i);
        }
    }

    if (pilotIndices.length <= 2) return;

    // Un-flag every pilot point except the outermost (first and last).
    for (let j = 1; j < pilotIndices.length - 1; j++)
    {
        geometry[pilotIndices[j]].properties.pilotPoint = undefined;
    }
}

// Remove past points/legs and informational points
export function pruneRouteGeometry(geometry: RouteGeometry): RouteGeometry
{
    const result: RouteGeometry = [];

    let lastPointNotPassed = false;
    for (const feature of geometry)
    {
        if (feature.geometry.type === "LineString" && lastPointNotPassed)
        {
            result.push(feature);
        }
        else if (feature.geometry.type === "Point" && !feature.properties.isPassed &&
                 (feature.properties.type === "Hard" || feature.properties.type === "Navigational"))
        {
            lastPointNotPassed = true;
            result.push(feature);
        }
    }

    return result;
}
